module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-shadow-1.077feb7f.png";